import { BlockBlobClient } from '@azure/storage-blob';

export async function uploadFileToBlobSas({
  sasUrl,
  file,
  blockSize,
  onProgress,
  abortSignal,
}: {
  sasUrl: string;
  file: File;
  blockSize: number;
  onProgress?: (loaded: number, total: number) => void;
  abortSignal?: AbortSignal;
}): Promise<void> {
  const client = new BlockBlobClient(sasUrl);
  await client.uploadData(file, {
    blockSize,
    maxSingleShotSize: blockSize,
    blobHTTPHeaders: file.type ? { blobContentType: file.type } : undefined,
    abortSignal,
    onProgress: onProgress
      ? (progress) => {
          if (progress.loadedBytes != null) {
            onProgress(progress.loadedBytes, file.size);
          }
        }
      : undefined,
  });
}
